module.exports = __webpack_public_path__ + "media/images/mars-bafa931aac6845a4e662badd038b7c86.svg";